import React, { useEffect, useRef, useState } from "react";

import { Input, Button, Image, Table, Select, Modal, DatePicker, message, Checkbox, QRCode, TimePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import DuesExcelView from "./Excel/DuesExcelView";
import AuthService from "../services/auth.service";
import { API_BASE_URL } from "../services/apiConfig";
import {API_BASE_URL_ISSUER} from "../services/apiConfig";
interface ClubInfo {
  club_seq: number;
  club_name: string;
  valid: boolean;
  club_category_seq: number;
  agentSeq: number;

}

interface DuesListView {
  SelectValue: string;
  selectedClubInfo: ClubInfo | null;
  selectmemberidsoket: any;
  onselectedDeviceNameChange: (selectedDeviceName: any) => void;
  onselectchangeupdate: (selectchangeroom: any) => void;
  profiledata: any;
}
const DuesListView: React.FC<DuesListView> = ({ SelectValue,selectedClubInfo, selectmemberidsoket, onselectedDeviceNameChange, profiledata, onselectchangeupdate }) => {
  const [selectedOption1, setSelectedOption1] = useState<string>("option1");
  const [searchValue, setSearchValue] = useState<string>("");
  const [excelData, setExcelData] = useState<any[]>([]);
  const [duesexcelData, setduesexcelData] = useState<any[]>([]);
  const [tempexcelData, settempexcelData] = useState<any[]>([]);
  const [searchOption, setSearchOption] = useState<string>("회원명");
  const [width, setWidth] = useState(window.innerWidth);
  const [contentLength, setcontentLength] = useState<string>("");
  const [token, settoken] = useState<string | null>(null);
  const [addition, setaddition] = useState(0);
  const [membercount, setmembercount] = useState<number>(0);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null); //엑셀뷰 선택한 데이터 행 출력
  const [selectedRowData, setSelectedRowData] = useState<any[] | null>(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [SelectHeaderValue, setSelectHeaderValue] = useState<string | null>(
    null
  );
  const handleExcelrowClick = (value: any) => {
    // console.log("(ExcelUpload) 찾아온 데이터:", value);
    setSelectedValue(value);
  };
  const handleRowSelect = (rowIndex: number, rowData: any[]) => {
    setSelectedRowIndex(rowIndex);
    setSelectedRowData(rowData);
    const selectedRowData = excelData[rowIndex + 1];
  };
  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    settoken(rawToken);
  }, []);

  useEffect(() => {
    if(token!==null){
      fetchDuesMemberDataAPI();
    }
  }, [token]);

  

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (token !== null) {

      setSelectHeaderValue(SelectValue);

    }
  }, [SelectValue]);
  const onSearchClick = async () => {
    ///검색기능
    // console.log("전체엑셀데이터:", excelData);
    // console.log("검색옵션 :", searchOption);
    // console.log("검색값:", searchValue);
    const excelHeader = excelData[0];

    if (searchValue === "") {
      // console.log("(ExcelUpload) 빈값" + excelData);

      // console.log("(ExcelUpload) 저장한값" + tempexcelData);
      setExcelData([]);
      setExcelData(tempexcelData);
      for (let i = 0; i < 1000; i++) {
        setExcelData((prevData) => [...prevData, []]);
      }
    } else {
      settempexcelData(excelData);
      // 검색 옵션과 검색 값으로 회원 찾기
      const foundMembers = excelData.filter((row) => {
        if (searchOption === "회원명" || searchOption === "name") {
          return row[0] === searchValue;
        } else if (searchOption === "phone") {
          return row[1] === searchValue;
        } else if (searchOption === "memberGrade") {
          return row[2] === searchValue;
        } else if (searchOption === "email") {
          return row[3] === searchValue;
        } else if (searchOption === "localname") {
          return row[4] === searchValue;
        }
        return false;
      });

      if (foundMembers.length === 0) {
        window.alert("검색결과가 없습니다.");
        return; // Exit early, no further action needed
      } else {
        // console.log("찾은 회원들:", foundMembers);
        setExcelData([excelHeader, ...foundMembers]);
        for (let i = 0; i < 1000; i++) {
          setExcelData((prevData) => [...prevData, []]);
        }
      }
    }
  };
  const fetchDuesMemberDataAPI = async () => {
    try {
      // console.log("(ExcelUpload) 선택클럽번호 : " + selectedClubInfo?.club_seq);
      // console.log("(ExcelUpload) 토큰: " + token);
      // console.log(`${API_BASE_URL}/club/agent/fee/list/${selectedClubInfo?.club_seq}?page=0&size=2000000&sort=agentClubFeeSeq,desc`)
      const response = await fetch(
        `${API_BASE_URL}/club/agent/fee/list/${selectedClubInfo?.club_seq}?page=0&size=2000000&sort=agentClubFeeSeq,desc`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("회비 첫번째 api끝");
      const data = await response.json();
      console.log("(ExcelUpload) 회비 Data from API:", data);
      if (data.data.content.length !== 0) {
        setcontentLength(data.data.content.length);
      }
      // console.log("(ExcelUpload) 회원수 :", contentLength);
      const excelHeader = ["회원명", "핸드폰번호", "회원구분", "납부여부"];

      const excelRows = data.data.content.map((item: any) => {
        const {
          agentClub,
          memberName,
          creator,
          mobileNubmer,
          memberGrade,
          flag,
        } = item;
        const flagValue = agentClub?.flag !== undefined ? agentClub.flag : flag;

        // console.log(
        //   `(ExcelUpload) Member Name: ${memberName}, Mobile Number: ${mobileNubmer}, Member Grade: ${memberGrade}, Creator: ${creator}, Flag: ${flagValue}`
        // );
        return [memberName, mobileNubmer, memberGrade, flag ? "y" : "n"];
      });

      // console.log("회비 " + excelRows);
      // 엑셀 데이터 업데이트
      setduesexcelData([excelHeader, ...excelRows]);
      for (let i = 0; i < 1000; i++) {
        setduesexcelData((prevData) => [...prevData, []]);
      }
    } catch (error) {
      const excelHeader = ["회원명", "핸드폰번호", "회원구분", "납부여부"];
    
      // 엑셀 데이터 업데이트 (헤더만 추가)
      setduesexcelData([excelHeader]);
  
      // 빈 행 추가
      for (let i = 0; i < 1000; i++) {
        setduesexcelData((prevData) => [...prevData, []]);
      }
  
      console.error("(ExcelUpload) Error fetching data:", error);
    }
  };

  const onSelectChange1 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value1 = event.target.value;
    setSelectedOption1(value1);
    setSearchOption(value1);

    // console.log(`(ExcelUpload) Selected: ${value1}`);
  };
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "20px" }}>
      <div style={{ fontSize: "24px" }}>
        | { } 회비
      </div>
      <div
        style={{
          padding: "5px",
          border: "1px solid #CACACA",
          marginLeft: "50px",
          marginBottom: "55px",
          width: width <= 1600 ? "300px" : "700px",
          marginTop: "50px",
        }}
      >

        <select
          value={selectedOption1}
          onChange={onSelectChange1}
          style={{
            border: "none",
            borderRadius: "5px",
            backgroundColor: "rgba(255, 255, 255, 0)",
            fontSize: "16px",
            cursor: "pointer",
            outline: "none",
          }}
        >
          <option
            value="name"
            style={{ color: "black", borderRadius: "5px" }}
          >
            회원명
          </option>
          <option
            value="phone"
            style={{ color: "black", borderRadius: "5px" }}
          >
            핸드폰번호
          </option>
          <option
            value="memberGrade"
            style={{ color: "black", borderRadius: "5px" }}
          >
            회원구분
          </option>
          <option
            value="email"
            style={{ color: "black", borderRadius: "5px" }}
          >
            이메일
          </option>
          <option
            value="localname"
            style={{ color: "black", borderRadius: "5px" }}
          >
            아이디
          </option>
        </select>
        |
        <Input
          value={searchValue}
          onChange={onInputChange}
          style={{
            width: width <= 1600 ? "200px" : "490px",
            height: "30px",
            marginRight: "10px",
            border: "none",
          }}
          placeholder="회원 검색"
          prefix={<SearchOutlined style={{ color: "rgba(0,0,0,.45)" }} />}
        />
        <button
          style={{
            cursor: "pointer",
            width: "50px",
            height: "30px",
            borderRadius: "10px",
            backgroundColor: "#ffff",
            border: "1px solid #2D5478", // Set border color and thickness
            color: "#000",
          }}
          onClick={onSearchClick}
        >
          찾기
        </button>
      </div>
      <div style={{ width: "50%", height: "100%" }}>
        <div
          style={{
            textAlign: "left",
            fontSize: "30px",
            paddingLeft: "50px",

          }}
        >
          회비명단
        </div>
        <div
          style={{
            width: "100%",
            height: width <= 1600 ? "200px" : "800px",
            marginTop: "30px",
          }}
        >

          <DuesExcelView
            data={duesexcelData}
            addition={addition || 0}
            membercount={membercount || 0}
            SelectValue={SelectHeaderValue || ""}
            onRowSelect={handleRowSelect}
            onExcelrowClick={handleExcelrowClick}
          />
        </div>
      </div>

    </div>


  );

};

export default DuesListView;
